import { render, staticRenderFns } from "./cdyyJmcdw.vue?vue&type=template&id=2357c52a&scoped=true"
import script from "./cdyyJmcdw.vue?vue&type=script&lang=js"
export * from "./cdyyJmcdw.vue?vue&type=script&lang=js"
import style0 from "./cdyyJmcdw.vue?vue&type=style&index=0&id=2357c52a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2357c52a",
  null
  
)

export default component.exports